import type { answerManagementData, answerManagementFilters } from "@/features/studentSimulationManagement/types.api";
import axiosInstance from "@/lib/axios";
import type { paginatedResponse } from "@/types/api/paginated.api";

export const getAnswers = async (
    userId: number | string,
    simulationId: number | string,
    filters: answerManagementFilters,
): Promise<paginatedResponse<answerManagementData>> => {
    const { data } = await axiosInstance.get<paginatedResponse<answerManagementData>>(
        `reports/manage/student/${userId}/simulation/${simulationId}/answers/`,
        {
            params: filters,
        },
    );
    return data;
};

export const updateStudentAnswers = async (
    userId: number | string,
    simulationId: number | string,
    answers: Record<string, string>,
): Promise<void> => {
    await axiosInstance.patch(
        `reports/manage/student/${userId}/simulation/${simulationId}/answers/`,
        { answers },
    );
};
